import { useMemo } from 'react';

/**
 * 从 formDetail 的三组关联画像数据中,提取所有有关联数据的人名集合。
 * 用于判断 ClickableName 是否应渲染为可点击链接。
 */
export function useExecutiveRelationMap(formDetail: any): Set<string> {
  return useMemo(() => {
    const names = new Set<string>();
    const sources = [
      formDetail?.vendorQccSeniorPersonInfos,
      formDetail?.vendorQccPersonHisJobCompanyInfos,
      formDetail?.vendorQccPersonHoldingCompanyInfos,
    ];
    for (const groups of sources) {
      if (!groups) continue;
      for (const g of groups) {
        if (g.personName && g.items?.length > 0) {
          names.add(g.personName);
        }
      }
    }
    return names;
  }, [formDetail]);
}
